<script>
  import { auth, isStaff, currentSheet, isVendor } from './stores/root.js'
  import VendorSelect from './VendorSelect.svelte'
  export let detail

  const { location } = detail

  $: if (!detail.enabled) {
    detail.qtyStart = null
    // detail.donate = false
  }

  $: lockDetail =
    $isVendor && $auth.user.vendor && $auth.user.vendor.id !== detail.vendor
</script>

<div class="location-row py-2">
  <div class="form-check form-switch">
    <label class="form-check-label fs-6 fw-bold" for={`enabled-${location.id}`}>
      {location.name}
    </label>
    <input
      disabled={lockDetail}
      class="form-check-input"
      type="checkbox"
      id={`enabled-${location.id}`}
      bind:checked={detail.enabled}
    />
  </div>

  {#if detail.enabled}
    <div class="row location-wrapper">
      <div class="col-4 col-sm-4 qty-wrapper">
        <div class="form-floating mb-3">
          <input
            type="text"
            class="form-control"
            id={`qtyStart-${location.id}`}
            placeholder="Qty Start"
            bind:value={detail.qtyStart}
            autofocus
            disabled={lockDetail}
          />

          <label for={`qtyStart-${location.id}`}>Qty Start</label>
        </div>
      </div>

      {#if $currentSheet.closed}
        <div class="col-4 col-sm-4 qty-wrapper mb-4">
          <div class="form-floating mb-3">
            <input
              type="text"
              class="form-control"
              id={`qtySold-${location.id}`}
              placeholder="Qty Sold"
              bind:value={detail.qtySold}
              disabled={lockDetail}
            />
            <label for={`qtySold-${location.id}`}> Qty Sold </label>
          </div>
        </div>
      {/if}


      {#if !$auth.user.vendor}
        <div class="col-8 pt-3">
          <VendorSelect
            disabled={!detail.enabled}
            bind:vendorId={detail.vendor}
          />
        </div>
      {/if}

      {#if lockDetail}
        <div class="fst-italic mt-2">
          Another vendor has signed up for this location
        </div>
      {/if}
    </div>
  {/if}
</div>

<style>
  .form-switch {
    height: calc(100% - 24px);
  }

  .location-row:last-child .location-wrapper {
    border-bottom: unset;
  }
  .location-wrapper {
    border-bottom: 1px solid #ced4da;
    padding: 0.5rem 0 1rem;
  }
</style>
